const DOCUMENT = 'TALENT_PAST_JOBS_';

const actions = {
  LOAD: DOCUMENT + 'LOAD',
  LOAD_SUCCESS: DOCUMENT + 'LOAD_SUCCESS',
  LOAD_MULTI_DAY_SUCCESS: DOCUMENT + 'LOAD_MULTI_DAY_SUCCESS',
  CLEAR_STORE: DOCUMENT + 'CLEAR_STORE',

  loadData: payload => ({ type: actions.LOAD, payload }),

  loadDataSuccess: payload => ({ type: actions.LOAD_SUCCESS, payload }),

  loadMultiDayDataSuccess: data => ({
    type: actions.LOAD_MULTI_DAY_SUCCESS,
    payload: data,
  }),

  clearStore: payload => ({ type: actions.CLEAR_STORE, payload }),
};

export default actions;
